export default "__VITE_ASSET__CgLY5rom__"